<div class="intro">
    <p>Select a Lumia board where the role tasks will be exported to.</p>
</div>

<div class="mt-3">
    <label class="mb-2">Destination Board</label>
    <adapt-select-board [boards]="board && [board]"
                        (boardsChange)="onBoardsChange($event)"
                        [required]="true"
                        [allowMultiSelection]="false"
                        [showEditableBoardsOnly]="true"
                        [useDropDown]="false"
                        [showColouredIcon]="true"
                        [showTeamBoards]="true"
                        data-test="destination-board-selection"></adapt-select-board>
</div>
